import React from 'react';
import { testimonials, product } from '../mock';
import { Star } from 'lucide-react';

export default function Testimonials() {
  return (
    <section className="px-5 sm:px-8 mt-24">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-wrap items-end justify-between gap-4 pb-10">
          <div>
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              <span className="tag-dot" /> Real Reviews
            </div>
            <h2 className="font-grotesk mt-3 text-4xl sm:text-5xl tracking-[-0.02em] font-medium">
              Athletes, founders,<br />and light sleepers <span className="font-display italic text-teal">love</span> TriMag.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={18} fill="currentColor" className="text-teal" />)}
            </div>
            <div>
              <div className="font-grotesk font-semibold text-lg leading-none">{product.rating}/5</div>
              <div className="text-[12px] text-neutral-500">{product.reviews} verified reviews</div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {testimonials.map((t, i) => (
            <figure key={i} className="rounded-2xl border border-black/5 dark:border-white/5 bg-white dark:bg-neutral-950 p-6 hover-lift flex flex-col">
              <div className="flex items-center gap-1 text-teal">
                {Array.from({ length: t.rating }).map((_, k) => <Star key={k} size={14} fill="currentColor" />)}
              </div>
              <blockquote className="mt-4 text-[15px] leading-relaxed text-neutral-700 dark:text-neutral-300 flex-1">“{t.text}”</blockquote>
              <figcaption className="mt-5 pt-4 border-t border-black/5 dark:border-white/5">
                <div className="font-grotesk font-semibold">{t.name}</div>
                <div className="text-[12px] text-neutral-500">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
